<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="distances-wrapper" [formGroup]="parentFormGroup">
  <div class="modal-section-title mb-2">
    {{ 'VENUE_DISTANCE.VENUES' | translate }}
  </div>
  <div formArrayName="venues" class="bg">
    <div *ngFor="let venue of parentFormGroup.get('venues')?.controls; let i = index" class="single-distance-box">
      <div class="row g-0" [formGroupName]="i">
        <div [ngClass]="venue.get('venue').value ? 'col-sm-6' : 'col-sm-7'">
          <div class="form-group">
            <app-venue-select
              [parentFormGroup]="venue"
              [distance]="distance"
              (change)="changeVenue($event, i)"
              class="venue-select-wrapper"
            ></app-venue-select>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group">
            <input
              type="number"
              class="form-control venue-distance-input"
              formControlName="distance"
              placeholder="{{ 'VENUE_DISTANCE.KM' | translate }}"
            />
          </div>
        </div>

        <div class="col-sm-1" *ngIf="venue.get('venue').value">
          <button
            type="button"
            class="btn btn-warning btn-fill-distance"
            [ngbTooltip]="'VENUE_DISTANCE.AUTOFILL_DISTANCE' | translate"
            (click)="fillDistance(i)"
          >
            <i class="fal fa-long-arrow-left"></i>
          </button>
        </div>

        <div class="col-sm-1">
          <button type="button" class="btn btn-danger btn-remove-venue" (click)="removeVenue(i)">
            <i class="fal fa-times"></i>
          </button>
        </div>

        <div class="col-sm-12">
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              formControlName="note"
              [placeholder]="'VENUE_DISTANCE.NOTE' | translate"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between">
      <div>
        <app-venues-in-range
          [parentFormGroup]="parentFormGroup"
          [coordinates]="{
            lat: parentFormGroup.get('lat').value,
            long: parentFormGroup.get('long').value
          }"
          [city_id]="parentFormGroup.get('city_id').value"
        ></app-venues-in-range>
      </div>
      <div>
        <button
          *ngIf="parentFormGroup.get('venues')?.controls.length > 0"
          type="button"
          class="btn btn-xs btn-warning mb-2"
          (click)="fillAllDistances()"
        >
          {{ 'VENUE_DISTANCE.FILL_ALL_DISTANCES' | translate }}
        </button>

        <button type="button" class="btn btn-xs btn-primary mb-2" (click)="addVenue()">
          {{ 'VENUE_DISTANCE.ADD_DISTANCE' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
